var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('base-page-heading',{attrs:{"title":"New Quote Template","show-back-button":""}}),_c('div',{staticClass:"content"},[_c('b-row',[_c('b-col',[_c('quote-templates-form',{on:{"on-submit":_vm.createTemplate,"on-save":_vm.onSave,"on-cancel":_vm.onCancel}})],1)],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }